module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace3-603a51412d760e8cd84f782e0eed80d8.jpg";